import BathroomTap from './BathroomTapContainer';

export default BathroomTap;
